import { combineReducers } from '@reduxjs/toolkit';

import sitesReducer from './reducers/sites.js';
import youthReducer from './reducers/youth.js';
import cycleReducer from './reducers/cycle.js';
import dataReducer from './reducers/data.js';
import messageReducer from './reducers/message.js';
import reportReducer from './reducers/report.js';
import administerReducer from './reducers/SmartWrapAdminister/administerSlice.js';
import careCoordinatorReducer from './reducers/SmartWrapCareCoordinator/careCoordinatorSlice.js';
import supervisorReducer from './reducers/SmartWrapSupervisor/supervisorSlice.js';
import dashboardReducer from './reducers/SmartWrapDashboard/dashboardSlice.js';

const smartwrapReducer = combineReducers({
    administer: administerReducer,
    careCoordinator: careCoordinatorReducer,
    supervisor: supervisorReducer,
    dashboard: dashboardReducer,
});

export default {
    sites: {
        reducer: sitesReducer,
    },
    youth: {
        reducer: youthReducer,
    },
    cycle: {
        reducer: cycleReducer,
    },
    data: {
        reducer: dataReducer,
    },
    messageReducer: {
        reducer: messageReducer,
    },
    report: {
        reducer: reportReducer,
    },
    smartwrap: {
        reducer: smartwrapReducer,
    },
};
